// This file is auto-generated by gen-constants.ts. Do not edit manually.

export default [
  "draft2019-09",
  "draft2020-12",
  "draft3",
  "draft4",
  "draft6",
  "draft7",
  "v1",
] as const;
